export const PUBLIC_ROUTE = {
  LANDING: '/',
  SIGN_IN: '/signin',
  SET_NEW_PASSWORD: '/setnewpassword',
  FORGOT_PASSWORD: '/forgotpassword',
  RESET_PASSWORD: '/resetpassword',
  MAINTENANCE: '/maintenance',
  BROWSER_NOT_SUPPORTED: '/browserNotSupported',
  CONFIRM_EMAIL: '/confirm-email/:token',
  INVITATION:'/gp/invitation'
};

export const PRIVATE_ROUTE = {

};
